/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone, {Collection} from 'backbone';

import {assert} from 'Asserts';
import {BasePrimer} from 'biojs/Sequence';
import SequenceAttributeCollection from 'components/SequenceAttributeCollection';
import ComponentSequencePrimer from 'molbio/primers/backbone/SequencePrimer';

import {Model as SequencePrimer} from './SequencePrimer';
import * as util from './Util';

export interface PrimerPairAttributes {
  primer_fwd_id: number | string | null;
  primer_rev_id: number | string | null;
  id: string | number;
  fromSubPart: boolean;
}

type GetAttribute<A extends keyof PrimerPairAttributes> = PrimerPairAttributes[A];

interface PrimerPair {
  get<K extends keyof PrimerPairAttributes>(key: K): PrimerPairAttributes[K];
}

class PrimerPair extends Backbone.Model {
  override defaults(): Partial<PrimerPairAttributes> {
    return {
      primer_fwd_id: null,
      primer_rev_id: null,
      fromSubPart: false,
    };
  }

  fromSubPart(): boolean {
    return this.get('fromSubPart');
  }

  forwardPrimerId(): GetAttribute<'primer_fwd_id'> {
    return this.get('primer_fwd_id');
  }

  reversePrimerId(): GetAttribute<'primer_rev_id'> {
    return this.get('primer_rev_id');
  }

  getPrimers<C extends Collection<M>, M extends SequencePrimer | ComponentSequencePrimer>(
    primers: C
  ): [M, M] {
    const forwardId = this.forwardPrimerId();
    const reverseId = this.reversePrimerId();
    const forward = primers.find((primer: M) => primer.id === forwardId);
    const reverse = primers.find((primer: M) => primer.id === reverseId);
    const primerIds = primers.map((primer: M) => primer.id).join(',');
    assert(forward != null, 'Called getPrimers but forward was undefined', {
      id: forwardId,
      existing: primerIds,
    });
    assert(reverse != null, 'Called getPrimers but reverse was undefined', {
      id: reverseId,
      existing: primerIds,
    });
    return [forward, reverse];
  }

  productLength<C extends Collection<M>, M extends SequencePrimer | ComponentSequencePrimer>(
    primers: C,
    circular: boolean,
    seqLength: number
  ): number {
    const [forward, reverse] = Array.from(this.getPrimers(primers));
    let length = util.productLength(
      [forward.start(), forward.end()],
      [reverse.start(), reverse.end()],
      circular,
      seqLength
    );
    // Don't forget overhang
    length += forward.overhangBases().length + reverse.overhangBases().length;
    return length;
  }

  override validate(attrs: PrimerPairAttributes): string | undefined {
    if (attrs.primer_fwd_id == null) {
      return 'Forward primer cannot be null';
    }
    if (attrs.primer_rev_id == null) {
      return 'Reverse primer cannot be null';
    }
    return undefined;
  }
}

class PrimerPairCollection extends SequenceAttributeCollection<PrimerPair, PrimerPairAttributes> {
  static override initClass(): void {
    this.prototype.model = PrimerPair;
    this.prototype.attributeName = 'primer_pairs';
  }

  findPair(fwd: BasePrimer, rev: BasePrimer): PrimerPair | null {
    return this.find((pair) => pair.get('primer_fwd_id') === fwd.id && pair.get('primer_rev_id') === rev.id);
  }

  batchName(): string {
    return 'primerPairs';
  }
}
PrimerPairCollection.initClass();

export {PrimerPair as Model, PrimerPairCollection as Collection};
